module.exports = __webpack_public_path__ + "img/gradient-purple-pink-orange.0980eef.png";